import moment from 'moment';
import { MonthEnum } from '@thinknet-gmbh/platform-common';

export const generateYearsOptions = (startYear: number, endYear: number): number[] => {
  const years = [];
  for (let year = startYear; year >= endYear; year--) {
    years.push(year);
  }
  return years;
};

export const generateTableData = (year: number) => {
  return Object.keys(MonthEnum).map((month, index) => {
    const monthDate = moment({ year, month: index })
      .add(6, 'hours')
      .toDate();
    return {
      monthNumber: index + 1,
      month,
      monthDate,
      file: {},
      status: 'noCreated',
    };
  });
};
